import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { env } from "~/env";

const _tmr = window._tmr || (window._tmr = []);

// https://ads.vk.com/help/general/sites/pixel#install_ajax

export const useVkAnalytics = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    _tmr.push({
      id: env.VITE_VK_ANALYTICS_ID,
      type: "pageView",
      url: location.pathname,
    });
  }, [location.pathname]);
};
